import React from 'react';
import { Server, Layers, Shield, TrendingUp, Database, Code, Globe, Lock } from 'lucide-react';

const About = () => {
  return (
    <div className="bg-white min-h-screen pt-32">
        {/* Header */}
        <div className="max-w-4xl mx-auto px-4 text-center mb-20">
             <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-indigo-50 text-indigo-700 font-bold mb-8">
                <Server className="h-4 w-4"/> Our Infrastructure
             </div>
             <h1 className="text-5xl font-extrabold text-slate-900 mb-8">Built for Scale & Performance.</h1>
             <p className="text-xl text-slate-600 leading-relaxed">
                 Searchy.io isn't just a website; it's a complex network of real-time bidding algorithms designed to maximize value for both users and advertisers.
             </p>
        </div>

        {/* 3 Columns Tech Stack */}
        <div className="bg-slate-900 py-24 mb-24">
             <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
                 <div className="p-6">
                     <Layers className="h-12 w-12 text-blue-500 mx-auto mb-6" />
                     <h3 className="text-white text-xl font-bold mb-4">Feed Integration</h3>
                     <p className="text-slate-400">Direct XML connections with Tier-1 providers including Google, Bing, and Yahoo networks.</p>
                 </div>
                 <div className="p-6">
                     <Shield className="h-12 w-12 text-purple-500 mx-auto mb-6" />
                     <h3 className="text-white text-xl font-bold mb-4">Compliance</h3>
                     <p className="text-slate-400">Strict adherence to TQ policies, filtering invalid traffic (IVT) before it reaches the feed.</p>
                 </div>
                 <div className="p-6">
                     <TrendingUp className="h-12 w-12 text-green-500 mx-auto mb-6" />
                     <h3 className="text-white text-xl font-bold mb-4">Optimization</h3>
                     <p className="text-slate-400">Automated bid adjustments (Smart Bidding) based on user intent signals and geolocation.</p>
                 </div>
             </div>
        </div>

        {/* RESTORED: Company Values / Our DNA */}
        <div className="max-w-7xl mx-auto px-4 pb-24">
           <div className="flex flex-col md:flex-row gap-16">
              <div className="w-full md:w-1/3">
                  <h3 className="text-3xl font-bold text-slate-900 mb-6">Our DNA</h3>
                  <p className="text-slate-600 mb-4 text-lg">Since our inception, we have focused on one thing: <span className="text-blue-600 font-bold">Efficiency</span>.</p>
                  <p className="text-slate-600 text-lg">We believe that the future of search is not about more results, but about the right results, delivered instantly and privately.</p>
              </div>
              <div className="w-full md:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-8">
                  <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100 hover:shadow-md transition">
                      <Database className="h-8 w-8 text-blue-600 mb-4" />
                      <h4 className="font-bold text-xl mb-2 text-slate-900">Data Driven</h4>
                      <p className="text-slate-500">Every decision is backed by petabytes of historical search data analysis.</p>
                  </div>
                  <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100 hover:shadow-md transition">
                      <Code className="h-8 w-8 text-blue-600 mb-4" />
                      <h4 className="font-bold text-xl mb-2 text-slate-900">Developer First</h4>
                      <p className="text-slate-500">Built by engineers, for engineers. Our API is robust, documented, and reliable.</p>
                  </div>
                  <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100 hover:shadow-md transition">
                      <Globe className="h-8 w-8 text-blue-600 mb-4" />
                      <h4 className="font-bold text-xl mb-2 text-slate-900">Global Reach</h4>
                      <p className="text-slate-500">Operating in over 190 countries with localized intent matching capabilities.</p>
                  </div>
                  <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100 hover:shadow-md transition">
                      <Lock className="h-8 w-8 text-blue-600 mb-4" />
                      <h4 className="font-bold text-xl mb-2 text-slate-900">Privacy Centric</h4>
                      <p className="text-slate-500">We do not store PII. User privacy is embedded in our architecture by design.</p>
                  </div>
              </div>
           </div>
        </div>
    </div>
  );
};

export default About;